import { configureStore } from '@reduxjs/toolkit';
import sidebarReducer from './slices/sidebarSlice'; 
import chartFilterReducer from './slices/chartfilterSlice';
import downloadCenterReducer from './slices/downloadCenterSlice';
import summaryDataReducer from './slices/summarydataSlice';
import reportFilterReducer from  './slices/reportfilterSlice';

const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
    chartfilter: chartFilterReducer,
    downloadCenter: downloadCenterReducer,
    summaryData: summaryDataReducer,
    report: reportFilterReducer,
  },
});

export default store;
